
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
    fixture: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      userScore: null,
    };
  },
  inject: [`lastUpdated`],
  computed: {
    teamId () {
      // TODO: Add support for womens
      return this.getDefault(`team`).id;
    },
    components () {
      return this.additionalConfig?.match_centre_config?.sidebar[this.type].match_centre_components;
    },
    dfpItem () {
      return this.additionalConfig?.match_centre_config?.sidebar_ad;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.checkScorePrediction();
    });
  },
  methods: {
    checkScorePrediction () {
      if (localStorage.scorePredictions) {
        const prediction = JSON.parse(localStorage.scorePredictions).find(prediction => prediction.id === this.fixture.id);

        if (prediction) {
          this.userScore = [prediction.home, prediction.away];
          this.disabled = true;
        }
      }
    },
    setScorePrediction (score) {
      this.userScore = score;
    },
  },
};
